module.exports = __webpack_public_path__ + "img/bgProfil.daf7dc6c.webp";